import supportedLocalesData from './supportedLocales.json';
import { AnnotatedLocal } from '@/i18n/interfaces/locales';

export function getSupportedLocales(): AnnotatedLocal[] {
	return Object.keys(supportedLocalesData).map((code) => {
		return {
			code,
			name: (supportedLocalesData as { [key: string]: string })[code],
		};
	});
}
